export default __webpack_public_path__ + "static/media/CircleYellow.c9839ee3.svg";